import compose from '../../../utils/components/_compose';
import injectTranslations from '../../../hocs/translation/injectTranslations';

import fr from './translations/fr';
import en from './translations/en';

import ExitModal, { ExitModalProps } from './ExitModal';

export * from './ExitModal';

const ComposedExitModal: (<Data>(
  props: ExitModalProps<Data>
) => React.ReactElement<ExitModalProps<Data>>) & {
  displayName: string;
} = compose<any>(
  injectTranslations('Core.ExitModal', [
    { language: 'fr', resource: fr },
    { language: 'en', resource: en },
  ]),
)(ExitModal);

export default ComposedExitModal;
